import { DIALOG_STATUS } from "../../../helper/enum/dialogEnum";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DialogState {
  status: DIALOG_STATUS.CLOSE | DIALOG_STATUS.OPEN;
  payload: any;
}

interface InitialState {
  [key: string]: DialogState;
}

const initialState: InitialState = {};

const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    setupDialog: (state, action: PayloadAction<{ key: string }>) => {
      state[action.payload.key] = {
        status: DIALOG_STATUS.CLOSE,
        payload: undefined,
      };
    },
    openDialog: (
      state,
      action: PayloadAction<{ key: string; payload?: any }>
    ) => {
      state[action.payload.key] = {
        status: DIALOG_STATUS.OPEN,
        payload: action.payload.payload,
      };
    },
    closeDialog: (state, action: PayloadAction<{ key: string }>) => {
      state[action.payload.key].status = DIALOG_STATUS.CLOSE;
    },
    clearDialog: (state, action: PayloadAction<{ key: string }>) => {
      state[action.payload.key] = {
        status: DIALOG_STATUS.CLOSE,
        payload: undefined,
      };
    },
  },
});

export const { setupDialog, openDialog, closeDialog, clearDialog } =
  dialogSlice.actions;

export default dialogSlice.reducer;
